import * as HoverCardPrimitive from '@radix-ui/react-hover-card';

import { cn } from '@/lib/utils';
import './animations.css';

export const HoverCard = HoverCardPrimitive.Root;
export const HoverCardTrigger = HoverCardPrimitive.Trigger;

export function HoverCardContent({
  className,
  align = 'center',
  sideOffset = 6,
  ...props
}: React.ComponentProps<typeof HoverCardPrimitive.Content>) {
  return (
    <HoverCardPrimitive.Portal>
      <HoverCardPrimitive.Content
        align={align}
        sideOffset={sideOffset}
        className={cn(
          'ui-anim-pop z-50 w-64 rounded-lg border border-border bg-popover p-3 text-sm text-popover-foreground shadow-lg',
          className,
        )}
        {...props}
      />
    </HoverCardPrimitive.Portal>
  );
}
